// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import Es6Promise from 'es6-promise';
import router from './router'
import Store from './store/index';
import axios from 'axios';
import VueLazyLoad from 'vue-lazyload'
import { priceFilter, sexFilter, jsTimestampFilter, stateFilter } from '@/utils/filters';
import taUrl from '@/static/backstageUrl';
import XLSX from 'xlsx';
import { getMD5 } from '@/utils/md5';

import App from './App';

// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/element-#D0011B/index.css'
import './assets/reset.css';
import './assets/site.css';
import './assets/font/iconfont.css';
import SubmitSuccess from '@/components/SubmitSuccess';
import MaskLogin from '@/components/MaskLogin';
import CustomForm from '@/components/CustomForm';
import Nothing from '@/components/Nothing';
import ServiceRate from '@/components/ServiceRate';

Es6Promise.polyfill();
Vue.prototype.$http = axios;
axios.defaults.headers['clientType'] = '1';
axios.defaults.headers['version'] = '1.0';
axios.defaults.headers['auth'] = '4f7087695bc9025846ccfdb39495f109';

Vue.prototype.URL_PREFIX = taUrl.apiUrl;
Vue.prototype.SHOW_TOKEN = process.env.NODE_ENV === 'development';

Vue.filter('SexState', sexFilter);
Vue.filter('PriceFilter', priceFilter);
Vue.filter('DateFilter', jsTimestampFilter);
Vue.filter('StateFilter', stateFilter)

Vue.prototype.MD5 = function MD5(value) {
  return getMD5(value);
};

Vue.use(ElementUI);
Vue.use(VueLazyLoad,{
  preLoad: 1.3,
  error:'../static/loading.gif',
  loading:'../static/loading.gif',
  attempt: 1
})

Vue.prototype.XLSX = XLSX;

Vue.component('SubmitSuccess', SubmitSuccess);
Vue.component('MaskLogin', MaskLogin);
Vue.component('CustomForm', CustomForm);
Vue.component('Nothing', Nothing);
Vue.component('ServiceRate', ServiceRate);

Vue.config.productionTip = false;

/* eslint-disable no-new */
const root = new Vue({
  el: '#app',
  router,
  store: Store,
  render: h => h(App),
  data: {
    eventHub: new Vue(),
  },
});

axios.interceptors.response.use(function (response) {
  // token过期错误码
  if (response.data.resCode === '10004' || response.data.resCode === '10009' || response.data.resCode === '10010'){
    switch (response.config.url) {
      case '/app/get/qiniu/bucket/token':
      case '/app/get/user/info/detail':
        root.$root.eventHub.$emit('clearToken', 'noMsg');
        break;
      default:
        root.$root.eventHub.$emit('clearToken', '');
        break;
    }
  }
  return response
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
    var _hmt = _hmt || [];
    (function() {
     //每次执行前，先移除上次插入的代码
     document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
     var hm = document.createElement("script");
     hm.src = "https://hm.baidu.com/hm.js?6143f9d6fd22a5fb27872975d01b2133";
     hm.id = "baidu_tj"
     var s = document.getElementsByTagName("script")[0];
     s.parentNode.insertBefore(hm, s);
    })();
  },0);
 } );


// WEBPACK FOOTER //
// ./src/main.js